// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import dict from "@/store/dict";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        dict
    },
    state: {
        // 面包屑导航路径
        breadcrumbPath: [],
        // 当前激活的菜单项
        activeMenuItems: {
            level1: null,
            level2: null,
            level3: null,
            level4: null
        },
        // 移动端菜单状态
        isMobileMenuOpen: false,
        // 当前展开的移动端子菜单
        expandedMobileMenus: []
    },
    mutations: {
        // 设置面包屑路径
        SET_BREADCRUMB_PATH(state, path) {
            state.breadcrumbPath = path
        },

        // 更新激活的菜单项
        SET_ACTIVE_MENU_ITEM(state, { level, item }) {
            state.activeMenuItems[level] = item

            // 当设置更高级别时，清空低级别的激活状态
            if (level === 'level1') {
                state.activeMenuItems.level2 = null
                state.activeMenuItems.level3 = null
                state.activeMenuItems.level4 = null
            } else if (level === 'level2') {
                state.activeMenuItems.level3 = null
                state.activeMenuItems.level4 = null
            } else if (level === 'level3') {
                state.activeMenuItems.level4 = null
            }

            // 自动更新面包屑路径
            state.breadcrumbPath = []
            if (state.activeMenuItems.level1) {
                state.breadcrumbPath.push(state.activeMenuItems.level1)
            }
            if (state.activeMenuItems.level2) {
                state.breadcrumbPath.push(state.activeMenuItems.level2)
            }
            if (state.activeMenuItems.level3) {
                state.breadcrumbPath.push(state.activeMenuItems.level3)
            }
            if (state.activeMenuItems.level4) {
                state.breadcrumbPath.push(state.activeMenuItems.level4)
            }
        },

        // 清空所有激活状态
        CLEAR_ACTIVE_MENU_ITEMS(state) {
            state.activeMenuItems = {
                level1: null,
                level2: null,
                level3: null,
                level4: null
            }
            state.breadcrumbPath = []
        },

        // 切换移动端菜单状态
        TOGGLE_MOBILE_MENU(state) {
            state.isMobileMenuOpen = !state.isMobileMenuOpen
            if (!state.isMobileMenuOpen) {
                state.expandedMobileMenus = []
            }
        },
        //
        // // 关闭移动端菜单
        // CLOSE_MOBILE_MENU(state) {
        //     state.isMobileMenuOpen = false
        //     state.expandedMobileMenus = []
        // },

        // 切换移动端子菜单展开状态
        TOGGLE_MOBILE_SUBMENU(state, menuPath) {
            const index = state.expandedMobileMenus.indexOf(menuPath)
            if (index === -1) {
                state.expandedMobileMenus.push(menuPath)
            } else {
                state.expandedMobileMenus.splice(index, 1)
            }
        },

        // 清空展开的移动端子菜单
        CLEAR_EXPANDED_MOBILE_MENUS(state) {
            state.expandedMobileMenus = []
        }
    },
    actions: {
        // 更新激活菜单项
        updateActiveMenuItem({ commit }, { level, item }) {
            commit('SET_ACTIVE_MENU_ITEM', { level, item })
        },

        // 根据路由更新激活状态
        updateActiveFromRoute({ commit, state }, route) {
            // 清空之前的激活状态
            commit('CLEAR_ACTIVE_MENU_ITEMS')

            // 根据当前路由匹配菜单项
            const matched = route.matched.filter(item => item.meta && item.meta.title)

            if (matched.length > 0) {
                // 第一级路由（Layout级别）
                if (matched[0].meta && matched[0].meta.title) {
                    commit('SET_ACTIVE_MENU_ITEM', {
                        level: 'level1',
                        item: {
                            path: matched[0].path,
                            title: matched[0].meta.title
                        }
                    })
                }

                // 第二级及更深的路由
                for (let i = 1; i < matched.length; i++) {
                    if (matched[i].meta && matched[i].meta.title) {
                        const level = `level${i + 1}`
                        commit('SET_ACTIVE_MENU_ITEM', {
                            level: level,
                            item: {
                                path: matched[i].path,
                                title: matched[i].meta.title
                            }
                        })
                    }
                }
            }
        },

        // 清空激活状态
        clearActiveMenuItems({ commit }) {
            commit('CLEAR_ACTIVE_MENU_ITEMS')
        },

        // 切换移动端菜单
        toggleMobileMenu({ commit }) {
            commit('TOGGLE_MOBILE_MENU')
        },

        // // 关闭移动端菜单
        // closeMobileMenu({ commit }) {
        //     commit('CLOSE_MOBILE_MENU')
        // },

        // 切换移动端子菜单
        toggleMobileSubmenu({ commit }, menuPath) {
            commit('TOGGLE_MOBILE_SUBMENU', menuPath)
        }
    },
    getters: {
        // 获取面包屑路径
        breadcrumbPath: state => state.breadcrumbPath,

        // 获取特定级别的激活菜单项
        activeMenuItem: state => level => state.activeMenuItems[level],

        // 获取所有激活的菜单项
        activeMenuItems: state => state.activeMenuItems,

        // 获取移动端菜单状态
        isMobileMenuOpen: state => state.isMobileMenuOpen,

        // 检查移动端子菜单是否展开
        isMobileSubmenuExpanded: state => menuPath => state.expandedMobileMenus.includes(menuPath)
    }
})
